import { render } from "./FacilityTab.vue?vue&type=template&id=78ee5f6c"
import script from "./FacilityTab.vue?vue&type=script&lang=js"
export * from "./FacilityTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__